import { render, staticRenderFns } from "./FormatedInput.vue?vue&type=template&id=7bb07246&"
import script from "./FormatedInput.vue?vue&type=script&lang=js&"
export * from "./FormatedInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports